import { useState } from "react";
import { AiFillStar } from "react-icons/ai";

const StarRating = ({ maxStars = 5, onRatingSelect, value = null }) => {
  const [hoveredStar, setHoveredStar] = useState<number | null>(null);
  const [selectedStar, setSelectedStar] = useState<number | null>(value);

  const handleMouseEnter = (index: number) => {
    setHoveredStar(index);
  };

  const handleMouseLeave = () => {
    setHoveredStar(null);
  };

  const handleClick = (index: number) => {
    setSelectedStar(index);
    onRatingSelect(index); // Pass the selected star to the parent
  };

  return (
    <div className="flex gap-1">
      {[...Array(maxStars)].map((_, index) => {
        const starIndex = index + 1;
        return (
          <AiFillStar
            key={index}
            className={`text-xl cursor-pointer ${
              starIndex <= (hoveredStar ?? selectedStar ?? 0)
                ? "text-yellow-500"
                : "text-gray-300"
            }`}
            onMouseEnter={() => handleMouseEnter(starIndex)}
            onMouseLeave={handleMouseLeave}
            onClick={() => handleClick(starIndex)}
          />
        );
      })}
    </div>
  );
};

export default StarRating;
